uniform float uTime;
uniform float uLineColorMode;
uniform float uFancyLineColorMode;
uniform vec3 uLineColor;
uniform vec3 uBackgroundColor;
uniform float uFading;
uniform float uLineThickness;
uniform float uLineHeight;
uniform float uMaxHeight;
uniform vec3 uHighColor;
uniform vec3 uLowColor;
uniform float uElevationColorMode;
uniform float uElevationColorStrength;
uniform float uELevationColorDiffuse;

varying vec2 vUv;
varying float vElevation;

void main() {
    float height = vElevation;

    // Compute which elevation color to use given the elevation
    vec3 elevationColor = mix(uLowColor, uHighColor, (1.0 + sign(height)) * 0.5);

    // Color to use outside lines is a mix between elevation color and raw background color depending on elevation:
    // pure raw background at elevation = 0 and pure elevation color at max elevation
    vec3 backgroundColor = mix(uBackgroundColor, elevationColor, uElevationColorMode * clamp(pow((abs(height) / uMaxHeight) * uElevationColorStrength, uELevationColorDiffuse), 0.0, 1.0));


    // Calculate the position within the current stripe
    float position = mod(height, uLineHeight);

    // Calculate the threshold for coloring based on the percentage uLineThickness
    float threshold = uLineHeight * uLineThickness;

    // Use a step function to switch between colors
    // It returns 0.0 when position < threshold and 1.0 when position >= threshold
    float t = step(threshold, position);

    // // Use smoothstep for anti-aliasing the stripe edges
    // t = smoothstep(threshold - 0.001, threshold + 0.001, position);


    // Line color (either user input or fancy)
    vec3 fancyColor = vec3(vUv, 0.5 * (sin(uTime * 1.0) + 1.0));
    vec3 lineColor = mix(uLineColor, fancyColor, uFancyLineColorMode);


    // Final color is either line color or background color depending on threshold
    vec3 finalColor = mix(lineColor, backgroundColor, t);
    // If line color mode is non-active, we take only background color
    finalColor = mix(backgroundColor, finalColor, uLineColorMode);


    // Compute opacity from the center
    float dist = length(vUv - 0.5);
    float opacity = smoothstep(0.5, uFading, dist);

    gl_FragColor = vec4(finalColor, opacity);
}